import React from 'react';
import { GiftIcon } from 'lucide-react';
import { AccordionItemData } from './Accordion';
import { Carousel } from './Carousel';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE, scrollToCompra } from '../lib/constants';
const bonos: AccordionItemData[] = [{
  title: '📚 Banco de 96 ejercicios resueltos paso a paso',
  body: 'PDF (portada + agrupado por tema) + Excel filtrable por materia / tema / nivel. Listo para TP, guías y repaso.'
}, {
  title: '🗓️ Planificador anual editable',
  body: 'Excel, 4 bimestres, mapeado a los 16 temas + NAP orientativo. Lo abrís, lo editás y lo entregás.'
}, {
  title: '📝 Banco de evaluaciones con rúbrica',
  body: 'Excel, 4 evaluaciones (una por bimestre) + hoja de rúbrica de corrección genérica.'
}, {
  title: '🧪 Laboratorios sin laboratorio',
  body: 'PDF, 15 experimentos con materiales caseros o de bajo costo. Objetivo, paso a paso, explicación y preguntas.'
}, {
  title: '🎮 Kit de gamificación',
  body: 'Word editable: 2 crucigramas (Química / Física, con solución) + bingo de fórmulas + 24 preguntas de trivia.'
}, {
  title: '🤝 Adaptaciones para alumnos con dificultades',
  body: 'PDF, 15 fichas simplificadas: un solo ejemplo fijo, vocabulario reducido y consigna recortada.'
}, {
  title: '💻 Guía de simuladores PhET',
  body: 'PDF, 15 simuladores mapeados por tema con uso sugerido en el aula.'
}, {
  title: '🖼️ Atlas Visual de Fisicoquímica',
  body: 'Colección de diagramas y láminas visuales de los 16 temas, listas para proyectar o imprimir.'
}];
export function Bonos() {
  return <section className="px-4 py-10" aria-labelledby="bonos-title" data-id="element-25" data-mp="3n2uqzjxxp4zk">
      <p className="mx-auto w-fit rounded-full bg-orange-500/20 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-orange-200" data-id="element-26" data-mp="3i6e6czpy18r8">
        Gratis solo por hoy
      </p>
      <h2 id="bonos-title" className="mt-3 text-center font-display text-xl font-extrabold text-white" data-id="element-27" data-mp="26qpf3w5npnkm">
        Hoy con tu kit también te llevás
      </h2>
      <p className="mt-2 flex items-center justify-center gap-1.5 text-center text-sm text-teal-100/75" data-id="element-28" data-mp="yp5ypr7m2gmy">
        <GiftIcon className="h-4 w-4 text-orange-300" aria-hidden="true" data-id="element-29" data-mp="ost32nsi9spk" />8
        bonos complementarios sin costo adicional
      </p>

      <button type="button" onClick={scrollToCompra} className="mt-5 block w-full overflow-hidden rounded-2xl ring-1 ring-white/15 focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-300" aria-label="Ver la oferta con los 8 bonos incluidos" data-id="element-30" data-mp="tqumj9tufu1k">
        <img src={PRODUCT_IMAGE} alt="Los 8 bonos complementarios del kit: planificador, banco de ejercicios, evaluaciones, laboratorios, gamificación y más" className="w-full" data-id="element-31" data-mp="634fxguwbgkr" />
      </button>

      <div className="mt-5" data-id="element-32" data-mp="3sabbawc6x1qi">
        <Carousel label="Bonos incluidos" data-id="element-33" data-mp="138jq3sfwtfr">
          {bonos.map((b, i) => <article key={b.title} className="flex h-full flex-col rounded-xl border border-orange-400/25 bg-[#0b2b2e]/85 p-4 backdrop-blur-sm" data-id="element-34" data-mp="15claf2v9gcv" data-mpi={i}>
              <div className="flex items-center gap-2" data-id="element-35" data-mp="39n25b0bh68lb">
                <span className="flex h-6 w-6 flex-none items-center justify-center rounded-md bg-orange-500/20 text-[11px] font-bold text-orange-200" data-id="element-36" data-mp="3nljruupn9f1n">
                  {i + 1}
                </span>
                <span className="rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-emerald-300" data-id="element-37" data-mp="fiz4hvwfgsc">
                  Gratis hoy
                </span>
              </div>
              <h3 className="mt-3 font-display text-[15px] font-bold leading-snug text-white" data-id="element-38" data-mp="a52hlmfp98mo">
                {b.title}
              </h3>
              <p className="mt-2 text-[13px] leading-relaxed text-teal-50/80" data-id="element-39" data-mp="593z2fh1yku6">
                {b.body}
              </p>
            </article>)}
        </Carousel>
      </div>

      <div className="mt-6" data-id="element-40" data-mp="f71np42tqjnb">
        <CTAButton label="Quiero el kit + los 8 bonos" sub="Los bonos se regalan solo por el día de hoy" data-id="element-41" data-mp="28nxl4fmrd2jz" />
      </div>
    </section>;
}